<div
    class="einstallen-number-pad-root"
    style="
        padding: 0 24px 0 24px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        max-width: 100%;
        min-height: 0;
        height: auto;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    "
>
    <kiene-page-header *ngIf="!hidePageHeader" [small]="true" [ueberschrift]="'Einstallen'"></kiene-page-header>

    <div *ngIf="hidePageHeader" class="one-row einstallen-abteil-row" style="margin-bottom: 2px">
        <mat-form-field style="width: 95%; min-width: 0" class="einstallen-abteil-field">
            <mat-label>Einstalldatum *</mat-label>
            <input
                data-cy="einstallen-number-pad-einstalldatum"
                matInput
                [matDatepicker]="pickerMobile"
                [readonly]="true"
                [formControl]="datumCtrl"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerMobile"></mat-datepicker-toggle>
            <mat-datepicker #pickerMobile></mat-datepicker>
        </mat-form-field>
    </div>

    <div class="one-row einstallen-abteil-row" style="align-items: flex-start; gap: 16px; margin-bottom: 2px">
        <mat-form-field style="width: 95%; min-width: 0" class="einstallen-abteil-field">
            <mat-label>Abteil</mat-label>
            <input [formControl]="abteilCtrl" data-cy="einstallen-number-pad-abteil" matInput />
            <button
                mat-icon-button
                matSuffix
                [disabled]="abteilCtrl.value === null"
                (click)="abteilCtrl.setValue(null)"
            >
                <mat-icon>clear</mat-icon>
            </button>
        </mat-form-field>
    </div>

    <div
        style="
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            gap: 12px 20px;
            margin: 0 0 8px 0;
        "
    >
        <div style="display: flex; align-items: center; gap: 8px">
            <mat-slide-toggle
                data-cy="einstallen-number-pad-gewicht-toggle"
                [formControl]="mitGewichtToggleCtrl"
            ></mat-slide-toggle>
            <p style="font-size: 0.85em; margin: 0">mit Gewicht</p>
        </div>
        <div style="display: flex; align-items: center; gap: 8px">
            <mat-slide-toggle
                data-cy="einstallen-number-pad-transponder-toggle"
                [formControl]="mitTransponderNummerToggleCtrl"
            ></mat-slide-toggle>
            <p
                style="font-size: 0.85em; margin: 0; cursor: pointer; user-select: none"
                (click)="changeTransponderNrToggle($event)"
            >
                mit Transpondernr.
            </p>
        </div>
    </div>

    <!--    <div class="one-row" style="height: 50px">-->
    <!--        <p style="-->
    <!--                width: 95%;-->
    <!--                text-align: center;-->
    <!--                font-family: monospace;-->
    <!--                max-width: 95%;-->
    <!--                overflow-wrap: break-word;-->
    <!--                border: 6px solid;-->
    <!--                border-radius: 5px;-->
    <!--            " [style.borderColor]="checkBorderColor" [style.fontSize]="fontSize"-->
    <!--            [style.borderStyle]="keinErgebnis ? 'solid' : 'dashed'">-->
    <!--            {{ numbers }}-->
    <!--        </p>-->
    <!--    </div>-->

    <div class="one-row" style="margin: 14px 0 6px 0; min-height: 20px; padding: 6px 0">
        <div style="width: 100%; text-align: left">
            <div class="one-row" style="height: 70px">
                <span class="spacer"></span>
                <!--        [style.borderStyle]="keinErgebnis ? 'solid' : 'dashed'"-->
                <!--        [style.borderColor]="checkBorderColor"-->
                <p
                    [ngStyle]="{
                        'font-weight': checkBorderColor === 'green' || checkBorderColor === 'red' ? 'bold' : 'normal'
                    }"
                    [style.color]="checkBorderColor"
                    [style.fontSize]="fontSize"
                    style="
                        width: 95%;
                        text-align: center;
                        font-family: monospace;
                        max-width: 95%;
                        overflow-wrap: break-word;
                        /*border: 6px solid;*/
                        /*border-radius: 5px;*/
                        padding: 8px;
                    "
                >
                    {{ numbers }}
                </p>
                <span class="spacer"></span>
            </div>
            <span *ngIf="isLoading">Suche Ohrmarke...</span>
            <div *ngIf="!isLoading">
                <span *ngIf="numbers.length < 5" style="display: block; text-align: center">
                    mind. 5 Zeichen - aktuell {{ numbers.length }}
                </span>
                <div *ngIf="numbers.length >= 5">
                    <span *ngIf="ohrmarken?.length > 0 && !ohrmarkeGefunden"> {{ ohrmarken?.length }} gefunden </span>
                    <span *ngIf="ohrmarkeGefunden">
                        {{ getFirstTenDigits(ohrmarke) }}
                        <span style="font-weight: bold">{{ getLastFiveDigits(ohrmarke) }}</span>
                    </span>
                    <span *ngIf="keinErgebnis" style="padding-bottom: 6px; display: block; text-align: center">
                        <div data-cy="einstallen-number-pad-manuell-text">Ohrmarke manuell hinzufügen</div>
                        <div style="font-size: 0.8em"> 10 Zeichen - aktuell {{ numbers.length }} </div>
                    </span>
                </div>
            </div>

            <!-- Ähnliche Ohrmarken anzeigen, wenn genau 5 Zeichen eingegeben wurden und mehrere gefunden wurden -->
            <div
                *ngIf="!isLoading && numbers.length === 5 && ohrmarken && ohrmarken.length > 1"
                style="margin: 12px 0; max-height: 200px; overflow-y: auto"
            >
                <div style="margin-bottom: 8px; font-weight: bold; color: #666; font-size: 0.9em">
                    Ähnliche Ohrmarken ({{ ohrmarken.length }}):
                </div>
                <div
                    *ngFor="let tier of ohrmarken"
                    class="aehnliche-ohrmarke-item"
                    (click)="ohrmarkeUebernehmen(tier)"
                >
                    <div style="display: flex; align-items: center; justify-content: space-between">
                        <div>
                            <div style="font-weight: bold; font-family: monospace; font-size: 1em">
                                {{ tier.ohrmarke_notnull || tier.ohrmarke || tier.ohrmarke15 || tier.ohrmarke_kurz }}
                            </div>
                            <div style="font-size: 0.85em; color: #666" *ngIf="tier.rasse || tier.geschlecht">
                                {{ tier.rasse }} {{ tier.geschlecht }}
                            </div>
                        </div>
                        <mat-icon style="color: #4caf50; font-size: 20px; width: 20px; height: 20px"
                            >arrow_forward</mat-icon
                        >
                    </div>
                </div>
            </div>

            <div style="margin: 12px 0 10px 0">
                <span class="spacer"></span>
                <div class="one-row einstallen-number-pad-row" style="margin-bottom: 6px">
                    <span class="spacer"></span>
                    <button
                        (click)="addNumber(1)"
                        mat-button
                        data-cy="einstallen-number-pad-1"
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        1
                    </button>
                    <div style="width: 12px"></div>
                    <button
                        (click)="addNumber(2)"
                        data-cy="einstallen-number-pad-2"
                        mat-button
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        2
                    </button>
                    <div style="width: 12px"></div>
                    <button
                        (click)="addNumber(3)"
                        mat-button
                        data-cy="einstallen-number-pad-3"
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        3
                    </button>
                    <span class="spacer"></span>
                </div>
                <div class="one-row einstallen-number-pad-row" style="margin-bottom: 6px">
                    <span class="spacer"></span>
                    <button
                        (click)="addNumber(4)"
                        mat-button
                        data-cy="einstallen-number-pad-4"
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        4
                    </button>
                    <div style="width: 12px"></div>
                    <button
                        (click)="addNumber(5)"
                        data-cy="einstallen-number-pad-5"
                        mat-button
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        5
                    </button>
                    <div style="width: 12px"></div>
                    <button
                        (click)="addNumber(6)"
                        mat-button
                        data-cy="einstallen-number-pad-6"
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        6
                    </button>
                    <span class="spacer"></span>
                </div>
                <div class="one-row einstallen-number-pad-row" style="margin-bottom: 6px">
                    <span class="spacer"></span>
                    <button
                        (click)="addNumber(7)"
                        mat-button
                        data-cy="einstallen-number-pad-7"
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        7
                    </button>
                    <div style="width: 12px"></div>
                    <button
                        (click)="addNumber(8)"
                        data-cy="einstallen-number-pad-8"
                        mat-button
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        8
                    </button>
                    <div style="width: 12px"></div>
                    <button
                        (click)="addNumber(9)"
                        mat-button
                        data-cy="einstallen-number-pad-9"
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        9
                    </button>
                    <span class="spacer"></span>
                </div>
                <div class="one-row einstallen-number-pad-row" style="margin-bottom: 6px">
                    <span class="spacer"></span>
                    <div
                        *ngIf="!ohrmarkeGefunden && !keinErgebnis"
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                            background-color: lightgray;
                        "
                    ></div>

                    <button
                        (click)="check()"
                        *ngIf="ohrmarkeGefunden || keinErgebnis"
                        [disabled]="!canSubmitNumbers && !ohrmarkeGefunden && !isLoading"
                        [style.backgroundColor]="checkBackgroundColor"
                        data-cy="einstallen-number-pad-check"
                        mat-button
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        <mat-icon *ngIf="ohrmarkeGefunden && !keinErgebnis" [style.color]="checkColor"
                            >{{ ohrmarkeGefunden ? "check" : "stop" }}
                        </mat-icon>
                        <mat-icon
                            *ngIf="keinErgebnis && !ohrmarkeGefunden && hasFullOhrmarkeInput"
                            [style.color]="checkColor"
                        >
                            add
                        </mat-icon>
                    </button>

                    <div style="width: 12px"></div>
                    <button
                        (click)="addNumber(0)"
                        mat-button
                        data-cy="einstallen-number-pad-0"
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        0
                    </button>
                    <div style="width: 12px"></div>
                    <button
                        (click)="backspace()"
                        data-cy="einstallen-number-pad-backspace"
                        mat-button
                        style="
                            width: 70px;
                            height: 70px;
                            border-radius: 50%;
                            background-color: lightgray;
                            font-weight: bold;
                            font-size: 1.8em;
                            touch-action: manipulation;
                        "
                    >
                        <mat-icon>backspace</mat-icon>
                    </button>
                    <span class="spacer"></span>
                </div>
                <span class="spacer"></span>
            </div>

            <!-- Geschlechtsauswahl unterhalb des Tastenfeldes -->
            <div *kienePermission="[11013]">
                <!-- 
                    Bei 10 Zeichen: immer anzeigen
                    Bei 5 Zeichen: nur anzeigen wenn:
                      - Eine Ohrmarke gefunden wurde (ohrmarkeGefunden) ODER
                      - Kein Ergebnis gefunden wurde UND es gibt keine oder nur 1 ähnliche Ohrmarke
                      - NICHT anzeigen wenn mehrere ähnliche Ohrmarken gefunden wurden (ohrmarken.length > 1)
                -->
                <div
                    *ngIf="
                        hasFullOhrmarkeInput ||
                        (numbers.length === 5 && ohrmarken && ohrmarken.length <= 1 && (ohrmarkeGefunden || keinErgebnis))
                    "
                    style="margin-top: 10px; text-align: center"
                >
                    <div style="display: flex; gap: 10px; align-items: center; justify-content: center">
                        <button
                            (click)="
                                geschlechtCtrl.value === 1 ? geschlechtCtrl.setValue(null) : geschlechtCtrl.setValue(1)
                            "
                            [style.backgroundColor]="geschlechtCtrl.value === 1 ? '#ff4444' : 'lightgray'"
                            [style.color]="geschlechtCtrl.value === 1 ? 'white' : 'black'"
                            mat-button
                            style="
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                                font-weight: bold;
                                font-size: 1.5em;
                                min-width: 50px;
                                padding: 0;
                            "
                        >
                            m
                        </button>
                        <button
                            (click)="
                                geschlechtCtrl.value === 2 ? geschlechtCtrl.setValue(null) : geschlechtCtrl.setValue(2)
                            "
                            [style.backgroundColor]="geschlechtCtrl.value === 2 ? '#ff4444' : 'lightgray'"
                            [style.color]="geschlechtCtrl.value === 2 ? 'white' : 'black'"
                            mat-button
                            style="
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                                font-weight: bold;
                                font-size: 1.5em;
                                min-width: 50px;
                                padding: 0;
                            "
                        >
                            w
                        </button>
                    </div>
                    <p style="font-size: 0.9em; text-align: center; margin-top: 8px; color: gray">Geschlecht</p>
                </div>
            </div>

            <div class="einstallen-scan-list einstallen-number-pad-overview">
                <div class="einstallen-scan-list__header">
                    <div class="einstallen-scan-list__title-group">
                        <h4 class="einstallen-number-pad-overview__title">Übersicht</h4>
                        <div class="einstallen-scan-list__stats">
                            <div class="einstallen-scan-list__stat">
                                <span class="einstallen-scan-list__stat-label">
                                    <span
                                        class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--desktop"
                                        >Tiere gesamt</span
                                    >
                                    <span
                                        class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--mobile"
                                        >Tiere</span
                                    >
                                </span>
                                <span class="einstallen-scan-list__stat-value" data-cy="einstallen-number-pad-tiere-gesamt">{{
                                    currentScanErgebnis?.anzahl_tiere_datensaetze
                                }}</span>
                            </div>
                            <div class="einstallen-scan-list__stat">
                                <span class="einstallen-scan-list__stat-label">
                                    <span
                                        class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--desktop"
                                        >Akt. Abteil</span
                                    >
                                    <span
                                        class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--mobile"
                                        >Abteil</span
                                    >
                                </span>
                                <span class="einstallen-scan-list__stat-value" data-cy="einstallen-number-pad-akt-abteil">{{
                                    currentScanErgebnis?.anzahl_abteil || '---'
                                }}</span>
                            </div>
                            <div class="einstallen-scan-list__stat">
                                <span class="einstallen-scan-list__stat-label">
                                    <span
                                        class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--desktop"
                                        >Pass</span
                                    >
                                    <span
                                        class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--mobile"
                                        >Pass</span
                                    >
                                </span>
                                <span class="einstallen-scan-list__stat-value" data-cy="einstallen-number-pad-pass-gescannt">{{
                                    passGescanntDisplay
                                }}</span>
                            </div>
                            <div class="einstallen-scan-list__stat">
                                <span class="einstallen-scan-list__stat-label">
                                    <span
                                        class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--desktop"
                                        >Ohrmarke</span
                                    >
                                    <span
                                        class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--mobile"
                                        >Ohrm.</span
                                    >
                                </span>
                                <span class="einstallen-scan-list__stat-value" data-cy="einstallen-number-pad-ohrmarke-gescannt">{{
                                    ohrmarkeGescanntDisplay
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="padding: 8px 0 0 0; width: 100%">
                <h3 style="margin: 0 0 6px 0; text-align: left" class="einstallen-last-scans-title">
                    Letzte 10 Scans:
                </h3>
                <div
                    *ngIf="letzteScans?.length < 1"
                    class="einstallen-empty-state einstallen-empty-state--scans"
                    data-cy="einstallen-number-pad-scans-empty"
                >
                    <mat-icon>qr_code_scanner</mat-icon>
                    <p class="einstallen-empty-state__title">Noch keine Scans</p>
                    <p class="einstallen-empty-state__hint">
                        Ohrmarke &uuml;ber das Nummernfeld erfassen, um die letzten Scans hier zu sehen.
                    </p>
                </div>
                <ul
                    class="einstallen-last-scans-list"
                    *ngIf="letzteScans?.length > 0"
                    style="
                        list-style-type: none;
                        padding: 0;
                        margin: 0;
                        font-family: 'Courier New', sans-serif;
                    "
                >
                    <li
                        *ngFor="let scan of letzteScans"
                        class="einstallen-last-scans-item"
                        style="margin-bottom: 6px; display: flex; align-items: center"
                    >
                        <mat-icon
                            *ngIf="scan"
                            [style.color]="scan.success ? 'green' : '#9b0024'"
                            style="margin-right: 8px"
                        >
                            {{ scan.success ? "check" : "error" }}
                        </mat-icon>

                        <div
                            class="einstallen-last-scans-item__body"
                            [class.einstallen-last-scans-item__body--clickable]="canReklamierenScan(scan)"
                            (click)="canReklamierenScan(scan) && reklamationFuerScanHinzufuegen(scan)"
                        >
                            <div style="font-size: 1em; letter-spacing: 3px; display: flex; align-items: center; gap: 4px" class="einstallen-last-scans-ohrmarke">
                                <span class="einstallen-last-scans-scan-types" aria-hidden="true">
                                    <mat-icon
                                        class="einstallen-last-scans-scan-type-icon"
                                        [class.einstallen-last-scans-scan-type-icon--active]="hasOhrmarkeScanned(scan)"
                                        matTooltip="Ohrmarke gescannt"
                                    >label</mat-icon>
                                    <mat-icon
                                        class="einstallen-last-scans-scan-type-icon"
                                        [class.einstallen-last-scans-scan-type-icon--active]="hasPassScanned(scan)"
                                        matTooltip="Pass gescannt"
                                    >badge</mat-icon>
                                </span>
                                {{ scan?.ohrmarke_notnull }}
                            </div>
                            <div style="font-size: 0.8em; display: flex; gap: 10px" class="einstallen-last-scans-meta">
                                <span *ngIf="scan?.rasse">{{ scan.rasse }}</span>
                                <span *ngIf="scan?.geschlecht">{{ scan.geschlecht }}</span>
                                <span *ngIf="scan?.einstallgewicht">{{ scan.einstallgewicht }} kg</span>
                            </div>
                        </div>

                        <button
                            *ngIf="canReklamierenScan(scan)"
                            mat-icon-button
                            color="accent"
                            type="button"
                            matTooltip="Reklamieren"
                            data-cy="einstallen-number-pad-reklamieren"
                            (click)="reklamationFuerScanHinzufuegen(scan); $event.stopPropagation()"
                        >
                            <mat-icon>feedback</mat-icon>
                        </button>
                    </li>
                </ul>
            </div>
        </div>

        
    </div>
</div>
